import api from "./api"
import store from "../store/index"

export async function getAttachments() {
  const result = await api.get(
    `/api/v1/customer/${store.state.customerID}/attachments`
  )

  return result.data
}

export async function getReportAttachments() {
  const result = await api.get(
    `/api/v1/customer/${store.state.customerID}/attachments/person`
  )

  return result.data
}

export async function downloadAttachment({ attachmentID, fileName }) {
  const result = await api.get(
    `/api/v1/customer/${store.state.customerID}/attachments/${attachmentID}/download`,
    {
      responseType: "blob",
    }
  )

  const url = window.URL.createObjectURL(new Blob([result.data]))
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", fileName) //or any other extension
  document.body.appendChild(link)
  link.click()

  return result.data
}
